export default __webpack_public_path__ + "static/media/team-cards-social.ae856850.jpg";